import { createFileRoute } from "@tanstack/react-router";
import { RegisterForm } from "@/features/auth/RegisterForm";

export const Route = createFileRoute("/_marketing/register")({
  component: RegisterPage,
});

function RegisterPage() {
  return (
    <div className="flex flex-1 items-center justify-center px-4 py-16">
      <RegisterForm />
    </div>
  );
}
